import { Table } from 'antd';
import React, { useMemo } from 'react';

import Icon from '@ant-design/icons';
import InfoIcon from '@icons/emp/info.svg';
import { Empty, Header } from '@src/emp-3.0/components/Sankey/PathConversion/styled';

import { IUsersTable } from './typed';
import { getUserTimelineTempKey } from '@src/hooks/useGoToUserTimeline';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

const UsersTable: React.FC<IUsersTable> = ({
  dataSource = [],
  userKey,
  type,
  interval,
  handleEvent,
  filters,
  selectedNodeNames,
  ...restTableProps
}) => {
  const globalFilters = useMemo(
    () =>
      filters.map((group) => {
        return group
          .filter((item) => Array.isArray(item.value) && item.value[0] !== '')
          .map((item) => {
            return {
              field: item.field,
              op: item.op,
              value: item.code ? item.code : item.value[0],
              display: item.value[0],
              originalField: item.field,
            };
          });
      }),
    [filters],
  );
  const { userInfo } = useInitialInfoStore();
  const columns = [
    {
      title: 'Index',
      dataIndex: 'index',
      render: (text, record, index) => index + 1,
      width: 45,
    },
    {
      title: 'User',
      dataIndex: userKey,
      key: userKey,
      render: (text) => (
        <a
          style={{
            color: '#1890ff',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            cursor: 'pointer',
          }}
          rel="noopener noreferrer"
          href="#"
          onClick={(event) => {
            handleEvent?.(event, {
              userId: undefined,
              clientId: text,
              type: 'client',
              interval,
              eventNames: selectedNodeNames,
              globalFilters,
            });
          }}
          target="_blank"
          onContextMenu={(event) => {
            handleEvent?.(event, {
              userId: undefined,
              clientId: text,
              type: 'client',
              interval,
              eventNames: selectedNodeNames,
              globalFilters,
            });
          }}
        >
          {text}
        </a>
      ),
    },
  ];
  return (
    <div style={{ marginBottom: 32 }}>
      <Header>
        <span style={{ flex: 1, padding: '4px 8px' }}>Sample Client Id</span>
      </Header>
      {dataSource.length > 0 ? (
        <Table
          columns={columns}
          dataSource={dataSource}
          size="small"
          showHeader={false}
          scroll={{ y: 400 }}
          rowKey={userKey}
          {...restTableProps}
        />
      ) : (
        <Empty>
          <Icon component={InfoIcon} style={{ fontSize: '14px' }} />
          {type === 'funnel' ? <span>No Data</span> : <span>Select a path to view</span>}
        </Empty>
      )}
    </div>
  );
};

export default UsersTable;
